import { http } from './http';
import { getWidgetId, replaceErrors} from '../utils/common'

// 用于标识组件link下载 KEY=${url} Value=${true/false}
const linkLoadedMap = {};
const styleCache = {};
const scriptCache = {};
const entryCache = {};

// for prefetch ajaxLoadStylesheet
// export function getExternalStyleSheet(url, opts = {}) {
export function ajaxLoadStylesheet(url, opts = {}) {
	const {
		fetchType
	} = opts;
	if (styleCache[url]) {
		return Promise.resolve(styleCache[url])
	} else {
		return http.request({url, fetchType}).then(response => {
			styleCache[url] = response.text();
			return styleCache[url];
		})
	}
}


// elementLoadStylesheet
export function elementLoadStylesheet (src) {
	// 检测是否已加载
	if (linkLoadedMap[src]) {
		return Promise.resolve();
	}
	return new Promise((resolve, reject) => {
		let link = document.createElement('link');
		link.setAttribute('rel', 'stylesheet');
		link.setAttribute('href', src);
		link.onload = function () {
			// 设置缓存标识
			linkLoadedMap[src] = true;
			resolve()
		};
		link.onerror = function () {
			reject()
		};
		document.getElementsByTagName('head')[0].appendChild(link);
	})
}

// for prefetch  ajaxLoadScript
// export function getExternalScript(url, opts = {}) {
export function ajaxLoadScript(url, opts = {}) {
	const {
		fetchType
	} = opts;
	if (scriptCache[url]) {
		return Promise.resolve(scriptCache[url])
	} else {
		return http.request({url, fetchType}).then(response => {
			scriptCache[url] = response.text();
			return scriptCache[url];
		})
	}
}


// elementLoadScript
export function elementLoadScript (scriptUrl) {
	return new Promise((resolve, reject) => {
		let scriptDom = document.createElement("script");
		scriptDom.type = "text/javascript";
		scriptDom.src = scriptUrl;
		scriptDom.onload = function () {
			resolve()
		};
		scriptDom.onerror = function () {
			reject()
		};
		document.body.appendChild(scriptDom);
	})
}



/**
 * FIXME to consistent with browser behavior, we should only provide callback way to invoke success and error event
 * @param entry
 * @param proxy
 * @param opts
 * @returns {Promise<>}
 */
export function execScripts(entry, proxy = window, opts = {}) {

	return ajaxLoadScript(entry, opts)
		.then(scriptsText => {

			if (entryCache[entry]) {
				return entryCache[entry];
			} else {
				return new Promise((resolve, reject) => {
					try {
						// 判断是否存在opts.scriptContentRouter方法（用于处理脚本内容）
						let scriptContent = opts.scriptContentRouter ? opts.scriptContentRouter(scriptsText, entry, opts) : scriptsText;
						let exportResult = null;
						// 判断是否存在opts.exportScriptModule方法（用于自定义导出）
						if (opts.exportScriptModule) {
							exportResult = opts.exportScriptModule(scriptContent, entry, opts);
						}
						// 判断是否有值，如果没有则继续使用默认方法导出
						if (exportResult){
							resolve(exportResult);
						} else {
							// 模拟commonjs环境
							let module = {exports: {}};
							let requireAlias = {
								'@pa/aladdin': 'aladdin',
								'vue': 'Vue'
							}
							let require = function(path){
								if (requireAlias[path]) {
									return window[requireAlias[path]];
								}
								return window[path];
							}
							Function('module', 'exports', 'require', scriptContent)(module, module.exports, require);
							resolve(module.exports);
						}
					} catch (e) {
						// entry error must be thrown to make the promise settled
						console.error(`[widget-loader]: error occurs while executing entry script ${entry}`);
						console.error(e);
						let widgetId = getWidgetId(entry);
						window?._tag?.trackEvent?.(widgetId, '组件超市加载器err',
							{'WT.param': JSON.stringify({
									errorMsg: JSON.stringify(e, replaceErrors)
								})});
						reject(e);
					}
				});
			}

		});
}

//execElementScripts
// export function execOfflineScripts(entry) {
export async function execElementScripts(entry) {
	let widgetId = getWidgetId(entry);
	console.log('widgetId: ', widgetId);

	await elementLoadScript(entry)

	return window[widgetId]
}